import type { Lang } from '@/lib/i18nRoutes';

// Geographic names that change between visitor languages. IJsselmeer and
// Markermeer are proper names in all three locales; the Wadden Sea is not.
export const SCHEMA_AREA_SERVED: Record<Lang, readonly string[]> = {
  nl: ['IJsselmeer', 'Waddenzee', 'Markermeer'],
  en: ['IJsselmeer', 'Wadden Sea', 'Markermeer'],
  de: ['IJsselmeer', 'Wattenmeer', 'Markermeer'],
};
